import { EFormControlType, EFormInputType } from '@common/enums/form.enum';

export const controlsLabels = {
    [EFormInputType.input]: 'control_entry_field',
    [EFormInputType.name]: 'control_name',
    [EFormInputType.phone]: 'control_phone',
    [EFormInputType.email]: 'control_email',
    [EFormInputType.date]: 'control_date',
    [EFormInputType.url]: 'control_url',
    [EFormInputType.question]: 'control_question',
    [EFormInputType.hidden]: 'control_hidden',
    [EFormInputType.address]: 'control_address',
    [EFormControlType.checkbox]: 'control_checkbox',
    [EFormControlType.radio]: 'control_radio',
    [EFormControlType.select]: 'control_dropdown_list',
    [EFormControlType.textarea]: 'control_textarea',
    [EFormInputType.file]: 'control_file',
    [EFormInputType.number]: 'control_number',
} as const;

type TranslationKeys = keyof typeof controlsLabels;
export type TranslationsType = Record<TranslationKeys, string>;
